import React, { Component } from "react";
import { connect } from "react-redux";

import { Link } from "react-router-dom";
import { settingsRoutes } from "../config/routes";

const LinkRow = ({ href, text }) => {
	return (
		<div style={{ marginBottom: 10, marginLeft: 0 }}>
			<Link style={{ fontSize: "1.1em" }} to={href}>
				{text}
			</Link>
		</div>
	);
};
class Settings extends Component {
	render() {
		return (
			<div style={{ paddingTop: 20, paddingLeft: 15 }}>
				<div>
					<h3 style={{ fontSize: 20 }}>Users & Security</h3>
					<LinkRow
						href={settingsRoutes.MY_PROFILE.href}
						text={settingsRoutes.MY_PROFILE.label}
					/>
					<LinkRow
						href={settingsRoutes.CHANGE_PASSWORD.href}
						text={settingsRoutes.CHANGE_PASSWORD.label}
					/>
					<LinkRow
						href={settingsRoutes.CONFIGURE_MFA.href}
						text={settingsRoutes.CONFIGURE_MFA.label}
					/>
					<LinkRow
						href={settingsRoutes.SHARE_PASSWORD_SETTINGS.href}
						text={settingsRoutes.SHARE_PASSWORD_SETTINGS.label}
					/>
				</div>

				{this.props.hasPermissionsAccess ||
				this.props.userRights.MANAGE_DEFAULT_MATTER_PERMISSIONS ? (
					<div>
						<h3 style={{ fontSize: 20 }}>Permissions & Access</h3>
						{this.props.hasPermissionsAccess ? (
							<LinkRow
								href={
									settingsRoutes.EDIT_PERMISSION_GROUPS.href
								}
								text={
									settingsRoutes.EDIT_PERMISSION_GROUPS.label
								}
							/>
						) : null}

						{this.props.userRights
							.MANAGE_DEFAULT_MATTER_PERMISSIONS ? (
							<LinkRow
								href={
									settingsRoutes
										.EDIT_DEFAULT_MATTER_PERMISSIONS.href
								}
								text={
									settingsRoutes
										.EDIT_DEFAULT_MATTER_PERMISSIONS.label
								}
							/>
						) : null}
					</div>
				) : null}
				<div>
					<h3 style={{ fontSize: 20 }}>Document Management</h3>
					<LinkRow
						href={settingsRoutes.DOCUMENT_STAMPING.href}
						text={settingsRoutes.DOCUMENT_STAMPING.label}
					/>
					<LinkRow
						href={settingsRoutes.MANDATORY_PROFILING.href}
						text={settingsRoutes.MANDATORY_PROFILING.label}
					/>
					<LinkRow
						href={settingsRoutes.VERSION_CONTROL.href}
						text={settingsRoutes.VERSION_CONTROL.label}
					/>
				</div>
				<div>
					<h3 style={{ fontSize: 20 }}>Lists & Tags</h3>

					<LinkRow
						href={settingsRoutes.MANAGE_DOCUMENT_TAGS.href}
						text={settingsRoutes.MANAGE_DOCUMENT_TAGS.label}
					/>
					<LinkRow
						href={settingsRoutes.MANAGE_DOCUMENT_TYPES.href}
						text={settingsRoutes.MANAGE_DOCUMENT_TYPES.label}
					/>
					<LinkRow
						href={settingsRoutes.MANAGE_DOCUMENT_STATUSES.href}
						text={settingsRoutes.MANAGE_DOCUMENT_STATUSES.label}
					/>
					<LinkRow
						href={settingsRoutes.MANAGE_CLIENT_TAGS.href}
						text={settingsRoutes.MANAGE_CLIENT_TAGS.label}
					/>
					<LinkRow
						href={settingsRoutes.MANAGE_MATTER_TAGS.href}
						text={settingsRoutes.MANAGE_MATTER_TAGS.label}
					/>
					<LinkRow
						href={settingsRoutes.MANAGE_MATTER_TYPES.href}
						text={settingsRoutes.MANAGE_MATTER_TYPES.label}
					/>
					<LinkRow
						href={settingsRoutes.MANAGE_OFFICE_BRANCH.href}
						text={settingsRoutes.MANAGE_OFFICE_BRANCH.label}
					/>
				</div>
				<div>
					<h3 style={{ fontSize: 20 }}>Exchange & Email</h3>
					<LinkRow
						href={settingsRoutes.UPDATE_EXCHANGE_URL.href}
						text={settingsRoutes.UPDATE_EXCHANGE_URL.label}
					/>

					<LinkRow
						href={settingsRoutes.GET_OUTLOOK_ADDIN_ADDRESS.href}
						text={settingsRoutes.GET_OUTLOOK_ADDIN_ADDRESS.label}
					/>
					<LinkRow
						href={
							settingsRoutes.MANAGE_SMART_FILE_ASSOCIATIONS.href
						}
						text={
							settingsRoutes.MANAGE_SMART_FILE_ASSOCIATIONS.label
						}
					/>
				</div>
				<div>
					<h3 style={{ fontSize: 20, marginLeft: 0 }}>Downloads</h3>
					<div style={{ marginBottom: 10, marginLeft: 0 }}>
						<a
							style={{ fontSize: "1.1em" }}
							href={this.props.launcherURL}
						>
							LexWorkplace Launcher
						</a>
					</div>
				</div>
				<div>
					<h3 style={{ fontSize: 20 }}>Integrations</h3>

					<LinkRow
						href={settingsRoutes.INTEGRATIONS.href}
						text={settingsRoutes.INTEGRATIONS.label}
					/>
				</div>
			</div>
		);
	}
}
const mapStateToProps = (state) => ({
	launcherURL: state.global.launcherURL,
	hasPermissionsAccess: state.user.hasPermissionsAccess,
	userRights: state.user.userRights,
});
export default connect(mapStateToProps, {})(Settings);
